import { EntityId } from 'entities-next/common'
import React, { useCallback, useMemo } from 'react'
import { FormHelpers, FormManager } from 'utils-next/forms'

import { UserDataFormContent } from './UserDataFormContent.component'
import { ApiUserData, User } from '../../../../../../../../entities-next/user'
import {
  parseUserFormDataToUser,
  parseUserToUserFormData,
  userDataFormValidationSchema,
  UserFormData,
} from './UserDataForm.data'

export type UserDataFormProps = {
  user: User
  onSubmit: (userId: EntityId, data: ApiUserData) => Promise<void>
  actionBarRef: React.MutableRefObject<any>
}

export function UserDataForm({ user, onSubmit, actionBarRef }: UserDataFormProps) {
  const submitHandler = useUserDataFormSubmitHandler(user.id, onSubmit)

  const initialValues = useMemo(() => parseUserToUserFormData(user), [user])
  return (
    <FormManager
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={userDataFormValidationSchema}
      initialValues={initialValues}
      onSubmit={submitHandler}
    >
      {(formikProps) => <UserDataFormContent actionBarRef={actionBarRef} {...formikProps} />}
    </FormManager>
  )
}

function useUserDataFormSubmitHandler(userId: EntityId, onSubmit: UserDataFormProps['onSubmit']) {
  return useCallback(
    async (data: UserFormData, { setSubmitting }: FormHelpers<UserFormData>) => {
      setSubmitting(true)
      const userData = await parseUserFormDataToUser(data)
      await onSubmit(userId, userData)
      setSubmitting(false)
    },
    [onSubmit, userId]
  )
}
